import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { ClassifyDialog } from "./CustomerClassTab";

const LEGACY = { special_regime: "zona_franca", government: "gobierno", foreign: "internacional" };
const LABELS = { zona_franca: "Zona Franca", ong: "ONG", diplomatico: "Diplomático", gobierno: "Gobierno",
  gobierno_exento: "Gobierno con exención", proyecto_especial: "Proyecto especial", internacional: "Internacional" };
const E44 = ["zona_franca", "ong", "diplomatico", "gobierno_exento", "proyecto_especial"];

export function FiscalClassBadge({ customer }) {
  const cls = LEGACY[customer.customer_type] || customer.customer_type || "regular";
  const doc = customer.exemption?.status === "aprobado";
  if (cls === "regular" && !doc) return <span className="text-xs text-muted-foreground">Normal</span>;
  const tag = E44.includes(cls) || doc ? "E44" : cls === "gobierno" ? "E45" : cls === "internacional" ? "E46" : "";
  return (
    <span className="text-[10px] px-1.5 py-0.5 rounded bg-sky-500/15 text-sky-700 dark:text-sky-300 font-bold uppercase whitespace-nowrap"
      title={doc ? `Documento: ${customer.exemption.doc_type} ${customer.exemption.doc_number || ""}` : ""} data-testid={`customer-fiscal-badge-${customer.id}`}>
      {LABELS[cls] || "Normal"}{tag ? ` · ${tag}` : ""}{doc ? " · Doc." : ""}
    </span>
  );
}

// Botón (escudo) en la lista de Clientes: abre la clasificación fiscal y la carga del documento de exención.
export function CustomerFiscalAction({ customer, onDone }) {
  const { can } = useAuth();
  const [open, setOpen] = useState(false);
  const [classes, setClasses] = useState([]);
  useEffect(() => { if (open && !classes.length) api.get("/fiscal/classes").then(({ data }) => setClasses(data)); }, [open, classes.length]);
  if (!can("contacts.fiscal_classify")) return null;
  return (
    <>
      <Button size="icon" variant="ghost" title="Clasificación fiscal (E44 / E45 / E46)" onClick={() => setOpen(true)} data-testid={`customer-fiscal-btn-${customer.id}`}>
        <ShieldCheck className="w-4 h-4" />
      </Button>
      {open && classes.length > 0 && (
        <ClassifyDialog customer={customer} classes={classes} onClose={() => setOpen(false)} onDone={() => { setOpen(false); onDone(); }} />
      )}
    </>
  );
}
